import { render, staticRenderFns } from "./AboutTheOrderEnforcement.vue?vue&type=template&id=75da79e6"
import script from "./AboutTheOrderEnforcement.vue?vue&type=script&lang=ts"
export * from "./AboutTheOrderEnforcement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports